import React from "react";

/**
 * Inline branded SVG payment method badges.
 * Used near the Stripe checkout button to communicate supported wallets.
 */

export function ApplePayBadge({ className = "" }) {
  return (
    <svg
      role="img"
      aria-label="Apple Pay"
      viewBox="0 0 40 16"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="16" rx="2" fill="#000000" />
      <path
        fill="#FFFFFF"
        d="M8.45 5.74c.27-.34.45-.81.4-1.27-.39.02-.86.26-1.14.6-.25.3-.47.78-.41 1.23.44.04.88-.22 1.15-.56zm.39.62c-.63-.04-1.16.36-1.46.36-.3 0-.76-.34-1.25-.34-.65 0-1.24.37-1.57.95-.67 1.16-.18 2.88.48 3.82.32.46.7.97 1.21.95.48-.02.67-.31 1.25-.31.59 0 .75.31 1.26.3.52-.01.85-.46 1.17-.92.37-.53.52-1.04.53-1.07-.01 0-1.02-.39-1.03-1.54-.01-.96.78-1.42.82-1.44-.45-.66-1.14-.74-1.38-.76zM14.62 4.6h-2.34v6.85h1.06v-2.34h1.32c1.39 0 2.36-.94 2.36-2.26 0-1.31-.95-2.25-2.4-2.25zm-.05 3.62h-1.23V5.49h1.23c.86 0 1.35.46 1.35 1.37 0 .9-.49 1.37-1.35 1.37zM21 9.61c0-1.05-.69-1.66-1.94-1.66-1.16 0-1.92.55-1.97 1.34h.96c.07-.36.43-.59.95-.59.66 0 1.01.31 1.01.85v.38l-1.32.08c-1.23.07-1.88.58-1.88 1.43 0 .87.67 1.43 1.64 1.43.65 0 1.27-.32 1.55-.84h.02v.78H21V9.61zm-1 .98c0 .61-.56 1.04-1.26 1.04-.55 0-.9-.26-.9-.66 0-.41.34-.66.97-.7l1.18-.07v.39zM23.95 13.25c-1.05 0-1.7-.43-1.83-1.15h1.04c.06.3.34.5.79.5.65 0 1.04-.32 1.04-.97v-.59h-.02c-.24.43-.66.69-1.31.69-1.04 0-1.7-.78-1.7-2 0-1.24.66-2.06 1.71-2.06.66 0 1.08.31 1.31.74h.02v-.65h1v3.81c0 .98-.81 1.68-2.05 1.68zm.04-2.36c.6 0 1.01-.43 1.01-1.18 0-.74-.41-1.18-1.01-1.18-.59 0-1 .43-1 1.18 0 .76.41 1.18 1 1.18z"
      />
    </svg>
  );
}

export function GooglePayBadge({ className = "" }) {
  return (
    <svg
      role="img"
      aria-label="Google Pay"
      viewBox="0 0 40 16"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="16" rx="2" fill="#FFFFFF" stroke="#3C4043" strokeWidth="0.5" />
      <path
        fill="#5F6368"
        d="M9.93 8.05v2.36h-.75V4.58h1.99c.5 0 .94.17 1.29.51.36.33.54.74.54 1.23 0 .5-.18.91-.54 1.23-.35.33-.79.49-1.29.49H9.93zm0-2.75v2.03h1.26c.3 0 .54-.1.74-.3.2-.2.3-.43.3-.71 0-.27-.1-.51-.3-.71-.19-.21-.44-.31-.74-.31H9.93zM14.55 6.3c.55 0 .99.15 1.31.44.32.3.48.7.48 1.21v2.46h-.72v-.55h-.03c-.31.46-.72.69-1.24.69-.44 0-.81-.13-1.1-.39-.3-.26-.45-.59-.45-.97 0-.41.15-.74.46-.98.31-.25.72-.37 1.24-.37.44 0 .81.08 1.1.24v-.17c0-.26-.1-.48-.31-.66-.2-.18-.45-.27-.73-.27-.42 0-.75.18-1 .53l-.66-.42c.36-.52.91-.79 1.65-.79zM13.6 9.21c0 .19.08.36.25.49.16.13.36.2.58.2.32 0 .6-.12.85-.36.25-.24.37-.51.37-.83-.24-.18-.56-.27-.99-.27-.31 0-.57.07-.78.22-.19.15-.28.33-.28.55zM20.42 6.44L17.92 12.2h-.78l.93-2.01-1.64-3.75h.81l1.18 2.85h.02l1.15-2.85h.83z"
      />
      <path
        fill="#4285F4"
        d="M25.55 7.55c0-.23-.02-.45-.06-.66h-3.06v1.25h1.75c-.07.42-.3.77-.66 1.01v.84h1.07c.62-.58.96-1.42.96-2.44z"
      />
      <path
        fill="#34A853"
        d="M23.45 9.99c-.3.2-.68.31-1.13.31-.86 0-1.59-.58-1.85-1.36h-1.1v.86c.55 1.09 1.69 1.84 2.95 1.84.89 0 1.65-.29 2.2-.79l-1.07-.86z"
      />
      <path
        fill="#FBBC04"
        d="M20.36 8.34c0-.22.04-.43.1-.63v-.86h-1.1c-.22.45-.35.95-.35 1.49 0 .54.13 1.04.35 1.49l1.1-.86c-.06-.2-.1-.41-.1-.63z"
      />
      <path
        fill="#EA4335"
        d="M22.32 6.34c.48 0 .92.17 1.27.49l.94-.94c-.57-.53-1.32-.86-2.21-.86-1.27 0-2.4.75-2.95 1.84l1.1.86c.26-.79.99-1.39 1.85-1.39z"
      />
    </svg>
  );
}

export function VisaBadge({ className = "" }) {
  return (
    <svg
      role="img"
      aria-label="Visa"
      viewBox="0 0 40 16"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="16" rx="2" fill="#1A1F71" />
      <path
        fill="#FFFFFF"
        d="M17.5 5.7l-2.1 5.7h-1.4l-1-3.9c-.1-.2-.1-.3-.3-.4-.3-.2-.7-.3-1.1-.4l0-.1h2.3c.3 0 .6.2.6.5l.5 2.7 1.3-3.2h1.2zm5.5 3.8c0-1.3-1.8-1.4-1.8-2 0-.2.2-.4.5-.4.2 0 .8-.1 1.4.2l.2-1.1c-.4-.1-.8-.2-1.4-.2-1.4 0-2.4.8-2.4 1.8 0 .8.7 1.2 1.2 1.5.5.2.7.4.7.6 0 .3-.4.4-.7.4-.6 0-1-.2-1.4-.4l-.2 1.1c.3.2.9.3 1.5.3 1.5 0 2.4-.7 2.4-1.8zM27 11.4h1.3l-1.1-5.7H26c-.3 0-.5.2-.6.4l-2.1 5.3h1.5l.3-.8h1.8l.1.8zm-1.6-1.9l.7-2 .4 2h-1.1zm-6.4-3.8l-1.2 5.7h-1.4l1.2-5.7h1.4z"
      />
    </svg>
  );
}

export function MastercardBadge({ className = "" }) {
  return (
    <svg
      role="img"
      aria-label="Mastercard"
      viewBox="0 0 40 16"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="16" rx="2" fill="#FFFFFF" stroke="#E5E5E5" strokeWidth="0.5" />
      <circle cx="16.5" cy="8" r="4.5" fill="#EB001B" />
      <circle cx="23.5" cy="8" r="4.5" fill="#F79E1B" />
      <path
        fill="#FF5F00"
        d="M20 4.66a4.49 4.49 0 010 6.68 4.49 4.49 0 010-6.68z"
      />
    </svg>
  );
}

export default function PaymentBadges({ className = "", variant = "light" }) {
  const isDark = variant === "dark";
  return (
    <div
      className={`flex flex-wrap items-center gap-2 ${className}`}
      data-testid="payment-badges"
      aria-label="Metodi di pagamento accettati"
    >
      <span
        className={`text-[10px] uppercase tracking-[0.18em] ${
          isDark ? "text-[#F9F8F6]/70" : "text-[#3A4F6B]"
        }`}
      >
        Accettiamo
      </span>
      <ApplePayBadge className="h-5" />
      <GooglePayBadge className="h-5" />
      <VisaBadge className="h-5" />
      <MastercardBadge className="h-5" />
    </div>
  );
}
